import { render, staticRenderFns } from "./KepuxuanjiaoMainPage.vue?vue&type=template&id=19330679&scoped=true"
import script from "./KepuxuanjiaoMainPage.vue?vue&type=script&lang=js"
export * from "./KepuxuanjiaoMainPage.vue?vue&type=script&lang=js"
import style0 from "./KepuxuanjiaoMainPage.vue?vue&type=style&index=0&id=19330679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19330679",
  null
  
)

export default component.exports